import * as AlertsService from '../api/services/Alerts';
import { useToast } from '../contexts/ToastContext';

interface UseSnoozeHook {
  snoozeAlert: (id) => void;
}

export const useSnooze = (): UseSnoozeHook => {
  const { addToast } = useToast();

  const snoozeAlert = async (id) => {
    const response = await AlertsService.snoozeAlert(id);

    if (response.type === 'error') {
      response.error.errors.forEach((error) => addToast({ severity: 'error', message: error }));
    } else {
      response.data.messages.forEach((message) => addToast({ severity: 'success', message }));
    }
  };

  return { snoozeAlert };
};
